let lastScrollTop = 0;
const stickyNav = document.querySelector(".mobile-sticky-nav");
const header = document.querySelector(".section-site-header");
const headerInner = document.querySelector(".mobile-sticky-nav.inner")
const threshold = 10; // Minimum scroll distance to detect direction change
const headerHeight = header.offsetHeight; // Header’s initial height

if(headerInner.dataset.page !== 'product'){
  window.addEventListener("scroll", function () {
    if(window.innerWidth >= 768){
      return
    }
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
  
    if (scrollTop <= headerHeight) {
      // Keep header visible if we're within the initial header height
      header.classList.remove("closed");
      stickyNav.classList.remove("hidden");
    } else if (Math.abs(scrollTop - lastScrollTop) > threshold) {
      if (scrollTop > lastScrollTop) {
        // Scrolling down
        stickyNav.classList.add("hidden");
        header.classList.remove("closed"); // Show header on scroll down
      } else {
        // Scrolling up
        stickyNav.classList.remove("hidden");
        header.classList.add("closed"); // Hide header on scroll up
      }
    }
    
    lastScrollTop = scrollTop;
  });
}
